import Header from 'Components/Header/Header';
import React, { useContext, useEffect, useState } from 'react'
import { FIRM } from 'Constants';
import { isUserVerifiedApi } from 'Constants';
import ProfessionalDetailsEdit from './ProfessionalDetailsEdit';
import QCRLogoMark from 'Components/Icons/QCRLogoMark';
import { IoIosLogOut } from "react-icons/io";
import { signOut } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';

import { Context } from 'Context/Context';
import MiniAvatar from 'Components/Icons/MiniAvatar';
import LitigationFunderProfile from './LitigationFunderProfile';
import LawFirmProfile from './LawFirmProfile';
import CompleteLawFirmProfile from './CompleteLawFirmProfile';


function CompleteProfilePage() {
  const {userDetails, makeApiCallFunc} = useContext(Context);
  const [isUserVerified, setIsUserVerified] = useState();

  useEffect(() => {
    
    if((userDetails?.verified && !userDetails?.isUserAssistant) || (userDetails?.isUserAssistant && userDetails?.profilePic) || (userDetails?.role === FIRM && userDetails?.verified)) //verified attorney and completed assistant
    {
        navigate("/attorney/casesFeed/availableCases");
    }
  }, [userDetails])
  const navigate = useNavigate();
   const signoutUser = async () => {
          try {
              await signOut();
              localStorage.clear();
              navigate("/");
          } catch (error) {
              console.log("error signing out", error);
          }
      }
  return (
    <div className='bg-white flex flex-col w-full items-center  col-span-6'>
        {/* Same navy bar as the rest of the app (no menu - the profile isn't complete yet) */}
        <div className='sticky top-0 z-30 flex items-center justify-between gap-3 w-full bg-navy px-4 lg:px-8 min-h-[52px] lg:min-h-[62px] lg:mb-10 font-plexsans'>
          <button type='button' onClick={()=>navigate("/attorney/profileCompletion")}
            className='flex items-center gap-[7px] lg:gap-[9px] bg-transparent border-0 p-0 cursor-pointer'>
            <QCRLogoMark size={18} color="#c9a26a"/>
            <span className='flex items-start gap-1'>
              <span className='font-semibold text-[12px] lg:text-[13px] leading-none tracking-[.05em] uppercase text-ivory whitespace-nowrap'>Quick Case Review</span>
              <span className='font-semibold text-[7.5px] lg:text-[8.5px] leading-none tracking-[.1em] text-gold'>BETA</span>
            </span>
          </button>
          <MiniAvatar size={28}/>
        </div>
        <div className={`flex flex-col lg:w-[70%] w-full ${userDetails?.role === 5 ? 'p-0' : 'p-4'} lg:p-4 mb-10 lg:shadow-md lg:mx-20 items-center`}>
        {/* The firm form has its own title (LawFirmProfileSteps); the others get one here */}
        {userDetails?.role !== 5 &&
          <div className='w-full flex flex-col gap-1.5 pb-5 mb-2 border-b border-navy/[.1] font-plexsans'>
            <h1 className='m-0 font-spectral font-normal text-[21px] lg:text-[30px] leading-[1.25] text-navy'>
              {userDetails?.isUserAssistant ? 'Complete your assistant profile'
                : userDetails?.isUserFunder ? 'Complete your litigation funder profile'
                : 'Complete your attorney profile'}
            </h1>
            <p className='m-0 text-[13.5px] leading-[1.55] text-navy/[.6]'>Enter your details so we can verify your account.</p>
          </div>}
          <div className='grid grid-cols-1 w-full '>
            {
            userDetails?.role === 5 ?
            <CompleteLawFirmProfile/>
            :
            userDetails?.isUserFunder ? 
            <LitigationFunderProfile showBack={false}/>
            :
          <ProfessionalDetailsEdit showBack={false}/>
            }

          </div>
</div>
       
    </div>
  )
}

export default CompleteProfilePage;